export default __webpack_public_path__ + "static/media/Sank.a24e739d.png";